module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 8
// module chunks = 0